import React from 'react'
import { SpeedDialInterface } from 'interfaces'
import { useHistory } from 'react-router'
import styled from 'styled-components'

interface Props {
  data: SpeedDialInterface
  onClick?: (e: any) => void
  className?: string
  iconClassName?: string
  backClassName?: string
  titleClassName?: string
  isSoon?: boolean,
  commingSoonMain?: string,
  isBadges?: boolean,
  number?: number,
  title?: string,
  subtitle?: string,
}

const MenuStatistic: React.FC<Props> = (props) => {
  const {
    data,
    onClick,
    className,
    iconClassName,
    backClassName,
    titleClassName,
    isSoon,
    isBadges,
    commingSoonMain,
    title,
    subtitle,
    number,
  } = props
  const history = useHistory()

  const BackIconBlend = styled.div`
     mix-blend-mode: color-burn;
  `;

  const clickHandler = (e: any): void => {
    e.preventDefault()
    if (data.link) history.push(data.link)
    if (onClick) onClick(e)
  }

  return (
    <div className={`${className ?? ''}`}>
      <div style={{
        display: 'inline-block', width: '80px', margin: '36px 25px'
      }}>
        <span className={iconClassName}>{data.icon} </span>
      </div>
      <div style={{ display: 'inline-block', width: '50%', }}>
        <div style={{
          fontWeight: 700, fontSize: '30px', lineHeight: '47px', color: '#fff'
        }}>
          {number}+
        </div>
        <div style={{
          fontWeight: 700, fontSize: '22px', lineHeight: '34px', color: '#fff'
        }}>
          {title}
        </div>
        <div style={{
          fontWeight: 700, fontSize: '13px', lineHeight: '20px', color: '#fff'
        }}>
          {subtitle}
        </div>
        <BackIconBlend>
          <span className={iconClassName}>{data.backIcon} </span>
        </BackIconBlend>
      </div>
    </div >
  )
}

export default MenuStatistic
